export const isNullOrEmpty = (val: string) => {
  return val === null || val === undefined || val.length === 0;
};
